import { CommunicationChannel } from "@mimber/schema"

/** Column display labels for each communication channel. */
export const CHANNEL_LABELS: Record<CommunicationChannel, string> = {
  [CommunicationChannel.EMAIL]: "Email",
  [CommunicationChannel.SMS]: "SMS",
  [CommunicationChannel.PUSH]: "Push",
}

/** Fixed column order so channels render consistently across sections. */
export const CHANNEL_ORDER: CommunicationChannel[] = [
  CommunicationChannel.EMAIL,
  CommunicationChannel.SMS,
  CommunicationChannel.PUSH,
]
